module.exports = __webpack_public_path__ + "img/wx.3796dad0.png";